import { useCurrentBookingMembershipDiscountDetail } from './use-current-booking-membership-discount-detail.hook';

/**
 * This hook returns true if the current booking has a bundled (Dis-loyalty) membership.
 */
export function useCurrentBookingIncludesBundledMembership() {
  return useCurrentBookingMembershipDiscountDetail().includesBundledMembership;
}
